enum ActionTypes {
  CREATE_BONUS_ENGINE = '@BONUS_PROGRAMS/CREATE_BONUS_ENGINE',
  DELETE_BONUS_ENGINE = '@BONUS_PROGRAMS/DELETE_BONUS_ENGINE',
  UPDATE_BONUS_ENGINE = '@BONUS_PROGRAMS/UPDATE_BONUS_ENGINE',
  GET_ALL_GAMES = '@BONUS_PROGRAMS/GET_ALL_GAMES',
  GET_ALL_BONUSES = '@BONUS_PROGRAMS/GET_ALL_BONUSES',
  GET_ALL_BONUSES_BY_BUNDLE = '@BONUS_PROGRAMS/GET_ALL_BONUSES_BY_BUNDLE',
  GET_PROVIDER_CATEGORIES = '@BONUS_PROGRAMS/GET_PROVIDER_CATEGORIES',
  GET_ALL_PROVIDERS = '@BONUS_PROGRAMS/GET_ALL_PROVIDERS',
  GET_ONE_BONUS_ENGINE = '@BONUS_PROGRAMS/GET_ONE_BONUS_ENGINE',
}

export default ActionTypes
